// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1J2ZX","footer":"styles_footer__iUd3K"};